<template>
    <el-breadcrumb class="v-breadcrumb" :class="{white:theme == 'white'}" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(option, index) in options" class="v-breadcrumb-item" :key="index" :to="option.to" >
            <span class="v-breadcrumb-item-text">{{ option.label }}</span>
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'VBreadcrumb',
    props: {
        options: {
            type: Array,
            default: () => []
        },
        theme:{
            default:'dark',
            validator(value) {
                return ['dark', 'white'].includes(value)
            }
        }
    }
})
</script>

<style lang="scss">
:root {
  --v-breadcrumb-text-color: var(--text-color);
  --v-breadcrumb-text-color-hover: var(--text-color-highlight);
  --v-breadcrumb-font-size: 14px;
  --v-breadcrumb-separator-text-color: var(--text-color-placeholder);
}
.v-breadcrumb {
  display: flex;
}
.v-breadcrumb-item {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  color: var(--v-breadcrumb-text-color);
}
.v-breadcrumb-item .el-breadcrumb__inner.is-link, .v-breadcrumb-item .el-breadcrumb__inner a {
  color: var(--v-breadcrumb-text-color);
}
.v-breadcrumb-item .el-breadcrumb__inner.is-link:hover, .v-breadcrumb-item .el-breadcrumb__inner a:hover {
  color: var(--v-breadcrumb-text-color-hover);
}
.v-breadcrumb-item:last-child .el-breadcrumb__inner {
  color: var(--v-breadcrumb-text-color);
}
.v-breadcrumb-item:last-child .el-breadcrumb__inner:hover, .v-breadcrumb-item:last-child .el-breadcrumb__inner a, .v-breadcrumb-item:last-child .el-breadcrumb__inner a:hover {
  color: var(--v-breadcrumb-text-color);
}
.v-breadcrumb-item .el-breadcrumb__separator {
  color: var(--v-breadcrumb-text-color);
}
.white .el-breadcrumb__item .el-breadcrumb__inner.is-link, .white .el-breadcrumb__item .el-breadcrumb__inner a {
  color: #fff;
}
.white .el-breadcrumb__item .el-breadcrumb__inner:hover {
  color: var(--v-breadcrumb-text-color-hover);
}
.white .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #fff;
}
.white .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover, .white .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .white .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover {
  color: #fff;
}
.white .el-breadcrumb__item .el-breadcrumb__separator {
  color: #fff;
}
</style>
